import CONFIG from '@/config'
import { handleCode, setAuthHeader } from '@/utils/authRedirect'
import { isArray } from '@/utils/validate'
import axios from 'axios'
import qs from 'qs'

const { baseURL, contentType, debounce, requestTimeout, successCode } = CONFIG
let loadingInstance

const NO_ERROR_API_URL_KEYWORD = ['/hhxc-business/businessInvStraightHairReportList/HairReport/doGet']

/**
 * @author maydays
 * @description axios初始化
 */
const instance = axios.create({
  baseURL,
  timeout: requestTimeout,
  headers: {
    'Content-Type': contentType,
    // Authorization: 'Basic aGh4YzpoaHhjcWF6',
  },
})

/**
 * @author maydays
 * @description axios请求拦截器
 */
instance.interceptors.request.use(
  config => {
    setAuthHeader(config)
    if (config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=UTF-8') config.data = qs.stringify(config.data)
    if (debounce.some(item => config.url.includes(item))) {
      //这里写加载动画
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * @author maydays
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
  response => {
    if (loadingInstance) loadingInstance.close()
    const { data, config, status, headers } = response
    const { code, message } = data
    // 操作正常Code数组
    const codeVerificationArray = isArray(successCode) ? [...successCode] : [...[successCode]]
    // 是否操作正常
    const isFile = config.responseType === 'blob' || (headers['content-disposition'] && headers['content-disposition'].includes('filename'))
    if (status == 200 || codeVerificationArray.includes(code) || (status == 200 && config.responseType === 'blob') || config.status == 200) {
      if (code !== '200' && !isFile && !NO_ERROR_API_URL_KEYWORD.includes(config.url)) {
        handleCode(code, message)
      }
      if (isFile) {
        const fileName = decodeURIComponent(headers['content-disposition']?.split('=')[1])
        return { file: data, fileName }
      }
      return data
    } else {
      handleCode(code, message)
      return data
      // return Promise.reject(`请求异常拦截: ${config.url}${message}` || 'Error')
    }
  },
  error => {
    if (loadingInstance) loadingInstance.close()
    const { response, message } = error
    if (error.response && error.response.data) {
      const { code } = response.data
      handleCode(code, response.data.message || message)
      return Promise.reject(error)
    } else {
      let { message } = error
      if (message === 'Network Error') {
        message = '接口连接异常'
      }
      if (message.includes('timeout')) {
        message = '接口请求超时'
      }
      if (message.includes('Request failed with status code')) {
        const code = message.substr(message.length - 3)
        message = '接口异常，code：' + code
      }
      handleCode(error.status)
      // Message.error(`后端接口未知异常`)
      return Promise.reject(error)
    }
  }
)

export default instance
